<div class="data-volumetry-table datatable" *ngIf="!isLoading">
  <div class="data-volumetry-table__header">
    {{ title }}
  </div>

  <mat-table class="datatable__table" [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef fxFlex="30" [translate]="'DATA_VOLUMETRY_TABLE.NAME'"> Name </mat-header-cell>
      <mat-cell *matCellDef="let value" fxFlex="30" fxFlex.xs="100">
        <span class="mobile-label" [translate]="'DATA_VOLUMETRY_TABLE.NAME'"> Name </span>
        {{ value.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesDone">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10" [translate]="'DATA_VOLUMETRY_TABLE.DONE'">
        Done
      </mat-header-cell>
      <mat-cell class="centered" *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
        <span class="mobile-label" [translate]="'DATA_VOLUMETRY_TABLE.DONE'"> Done </span>
        <span class="done-color">{{ value.totalMaintenancesDone }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesCanceled">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10" [translate]="'DATA_VOLUMETRY_TABLE.CANCELED'">
        Canceled
      </mat-header-cell>
      <mat-cell class="centered" *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
        <span class="mobile-label" [translate]="'DATA_VOLUMETRY_TABLE.CANCELED'"> Canceled </span>
        <span class="canceled-color">{{ value.totalMaintenancesCanceled }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesBacklog">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10" [translate]="'DATA_VOLUMETRY_TABLE.OTHERS'">
        Others
      </mat-header-cell>
      <mat-cell class="centered" *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
        <span class="mobile-label" [translate]="'DATA_VOLUMETRY_TABLE.OTHERS'"> Others </span>
        <span class="others-color">{{ value.totalMaintenancesBacklog }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenances">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10" [translate]="'DATA_VOLUMETRY_TABLE.TOTAL'">
        Total
      </mat-header-cell>
      <mat-cell class="centered" *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
        <span class="mobile-label" [translate]="'DATA_VOLUMETRY_TABLE.TOTAL'"> Total </span>
        <span class="total-color">{{ value.totalMaintenances }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="maintenancesByDay">
      <mat-header-cell *matHeaderCellDef fxFlex="30" [translate]="'DATA_VOLUMETRY_TABLE.MAINTENANCES_BY_PERIOD'">
        Maintenances by period
      </mat-header-cell>
      <mat-cell *matCellDef="let value" fxFlex="30" fxHide.xs>
        <area-chart [results]="value.maintenances"></area-chart>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="noData">
      <mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <span [translate]="'DATA_VOLUMETRY_TABLE.NO_MAINTENANCES'"> No maintenances find in this period </span>
      </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>

<!-- SKELETON-LOADER -->

<div class="data-volumetry-table datatable" *ngIf="isLoading">
  <div class="data-volumetry-table__header">
    <ngx-skeleton-loader [theme]="{ height: '18px', width: '100px', 'margin-bottom': '0px' }"></ngx-skeleton-loader>
  </div>

  <mat-table class="datatable__table" [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef fxFlex="30">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '70px', 'margin-bottom': '0px', 'margin-right': '10px' }"
        ></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesDone">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '70px', 'margin-bottom': '0px', 'margin-right': '10px' }"
        ></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesCanceled">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '70px', 'margin-bottom': '0px', 'margin-right': '10px' }"
        ></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenancesBacklog">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '70px', 'margin-bottom': '0px', 'margin-right': '10px' }"
        ></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="totalMaintenances">
      <mat-header-cell class="centered" *matHeaderCellDef fxFlex="10">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '70px', 'margin-bottom': '0px', 'margin-right': '10px' }"
        ></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="maintenancesByDay">
      <mat-header-cell *matHeaderCellDef fxFlex="30">
        <ngx-skeleton-loader [theme]="{ height: '18px', width: '100px', 'margin-bottom': '0px' }"></ngx-skeleton-loader>
      </mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  </mat-table>
</div>

<!-- SKELETON-LOADER -->
